export function AvatarSizes() {
  return (
    <div className="flex w-max items-end gap-4">
      <img
        src="https://docs.material-tailwind.com/img/face-2.jpg"
        alt="avatar"
        className="relative inline-block h-6 w-6 !rounded-full object-cover object-center"
      />
      <img
        src="https://docs.material-tailwind.com/img/face-2.jpg"
        alt="avatar"
        className="relative inline-block h-9 w-9 !rounded-full object-cover object-center"
      />
      <img
        src="https://docs.material-tailwind.com/img/face-2.jpg"
        alt="avatar"
        className="relative inline-block h-12 w-12 !rounded-full object-cover object-center"
      />
      <img
        src="https://docs.material-tailwind.com/img/face-2.jpg"
        alt="avatar"
        className="relative inline-block h-[58px] w-[58px] !rounded-full object-cover object-center"
      />
      <img
        src="https://docs.material-tailwind.com/img/face-2.jpg"
        alt="avatar"
        className="relative inline-block h-[74px] w-[74px] !rounded-full object-cover object-center"
      />
      <img
        src="https://docs.material-tailwind.com/img/face-2.jpg"
        alt="avatar"
        className="relative inline-block h-[110px] w-[110px] !rounded-full object-cover object-center"
      />
    </div>
  );
}
